import React, { Component, Fragment } from "react";
import Header from './Header';
import Footer from './Footer';
import { connect } from "react-redux";
import { showAlert } from '../store/actions/alert';
import { APP_LINK } from '../constants';

class DeleteAccount extends Component {

  constructor(props) {
    super(props)

    this.state = {};
 }

  componentDidMount() {
  }

 
  render() {

 
    const borderStyle = '2px solid #ff0000';

    return (
      <Fragment>
        <Header {...this.props} />
        
          <div style={{ 'paddingBottom': '30px' }}  className="work-list-area delete-list-area default-padding">
              <div className="container">
                <div className="warning">
                      <p style={{ 'color': 'white !important' }}><strong>Warning:</strong> Deleting your account is irreversible. All your data associated with this account will be permanently deleted.</p>
                </div>
                <div className="row content-center" id="overview">
                  <div className="col-md-8 info follow-me-top text-center">
                 
                <h3>Delete Your Account</h3>
                <div className="instructions">
                    <p><b>Please follow the steps below to delete your account:</b></p>
                    <ul>
                        <li>Enter your email address</li>
                        <li>Click "Delete Account" to proceed with account deletion.</li>
                        <li style={{'color': 'red'}}><i>Once deleted, your account and all associated data will be permanently removed.</i></li>
                    </ul>
                </div>
                    <a style={{ 'marginTop': '20px', 'marginBottom': '20px', 'width' : '200px' }}
                      className="btn circle btn-light border btn-md" data-toggle="modal"
                      data-target={'#deleteAccount'}>
                        Delete Account
                     </a>
                  </div>
                </div>
              </div>
          </div>
       
        <Footer {...this.props} />
      </Fragment>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showAlert: (message, isError) => {
      return dispatch(showAlert(message, isError));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);



// WEBPACK FOOTER //
// ./src/components/DeleteAccount.js